import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import logoleone from '../ext/images/logo2.png';
import logoscritta from '../ext/images/laservideo_scritta.png';
import { Glyphicon, Nav, Navbar, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import './NavMenu.css';
import UserProfile from './UserProfile';

export class NavMenu extends Component {
  displayName = NavMenu.name

  render() {
    return (
      <Navbar inverse fixedTop fluid collapseOnSelect>
            <Navbar.Header>
                <Navbar.Brand>
                    <div className="row">
                        <div className="col-6">
                            <img
                                alt="dd"
                                src={logoleone}
                                width="30"
                                height="30"
                                className="d-inline-block logo-nav-lion"
                            />
                        </div>
                        <div className="col-6">
                            <img
                                alt="dd"
                                src={logoscritta}
                                width="180"
                                height="45"
                                className="d-inline-block logo-nav-brand"
                            />
                        </div>
                    </div>
                </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
                <Nav>
                    {(UserProfile.IsAuth() === false) && <LinkContainer to={'/Login'} exact><NavItem><Glyphicon glyph='log-in' /> Login</NavItem></LinkContainer>}
                    {(UserProfile.IsAuth() === true) && <LinkContainer to={'/Login'} exact><NavItem ><Glyphicon glyph='log-out'/> Logout</NavItem></LinkContainer>}
                    {(UserProfile.IsAuth() === true && UserProfile.getLogin().level < 0) && <LinkContainer to={'/users'}><NavItem><Glyphicon glyph='user' /> Utenti</NavItem></LinkContainer>}
                    {(UserProfile.IsAuth() === true && UserProfile.getLogin().level < 0) && <LinkContainer to={'/Statistics'}><NavItem><Glyphicon glyph='stats' /> Statistiche</NavItem></LinkContainer>}
                    {(UserProfile.IsAuth() === true) && <LinkContainer to={'/registry'}><NavItem><Glyphicon glyph='edit' /> Anagrafica</NavItem></LinkContainer>}
                    {(UserProfile.IsAuth() === true) && <LinkContainer to={'/transfer'}><NavItem><Glyphicon glyph='transfer' /> Bonifici</NavItem></LinkContainer>}
                    {(UserProfile.IsAuth() === true) && <LinkContainer to={'/transaction'}><NavItem><Glyphicon glyph='transfer' /> Transazioni Entrate</NavItem></LinkContainer>}
                    {(UserProfile.IsAuth() === true) && <LinkContainer to={'/transactionOut'}><NavItem><Glyphicon glyph='transfer' /> Transazioni Uscite</NavItem></LinkContainer>}
                    {(UserProfile.IsAuth() === true) && <LinkContainer to={'/qrcodes'}><NavItem><Glyphicon glyph='qrcode' /> Pagamenti QR Code</NavItem></LinkContainer>}
                    {(UserProfile.IsAuth() === true) && <LinkContainer to={'/ecards'}><NavItem><Glyphicon glyph='credit-card' /> Pagamenti Carte</NavItem></LinkContainer>}
                    {(UserProfile.IsAuth() === true) && <LinkContainer to={'/EuronetCredits'}><NavItem><Glyphicon glyph='euro' /> Accrediti Euronet</NavItem></LinkContainer>}
                </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}
